import { QueryClientProvider } from '@tanstack/react-query';
import React from 'react';
import ReactDOM from 'react-dom/client';

import App from './App';
import { AttachmentsFilesProvider } from './context/attachmentFiles';
import { GlobalProvider } from './context/global';
import { WebsocketProvider } from './context/websocketMessage';
import { queryClient } from './lib/queryClient';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <GlobalProvider>
        <WebsocketProvider>
          <AttachmentsFilesProvider>
            <App />
          </AttachmentsFilesProvider>
        </WebsocketProvider>
      </GlobalProvider>
    </QueryClientProvider>
  </React.StrictMode>
);

reportWebVitals();
